export const VALIDATE_LINKED_SCREEN_ID = 'VALIDATE_LINKED_SCREEN_ID';
export const PLUGIN_ACTION_EVENT = 'PLUGIN_ACTION_EVENT';
export const REQUEST_USER_LIST = 'REQUEST_USER_LIST';